import { Injectable } from '@angular/core';

import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { ConfigurationControlService } from '../services/configuration/configurationControl.service';
import { TokenControlService } from '../services/state/tokenControl.service';


@Injectable()
export class NavigateDemoGuard {

  public activateDemo: Boolean;

  //Constructor de la clase
  constructor(
    private _router: Router,
    private _configurationService: ConfigurationService,
    private _configurationControlService: ConfigurationControlService,
    private _tokenControlService: TokenControlService) {
    this.activateDemo = false;
  }

  /*Necesario debido a implementacion de la interfaz CanActivate
    funcion principal del guard, verifica si se cumplen las
    condiciones para permitir la navegacion */
  // canActivate() {
  //   var URLactual = window.location;

  //   if (this._configurationControlService.urlActual == null || this._configurationControlService.urlActual == undefined) {
  //     this._configurationControlService.urlActual = URLactual.pathname;
  //   }

  //   let canActivate = false;
  //   if (this.activateDemo) {
  //     canActivate = true;
  //   } else {
  //     this._router.navigate(['/']);
  //   }
  //   return canActivate;
  // }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isAuthenticated = this._tokenControlService.token != null; // Verifica si hay un token
    const isLoginRoute = state.url === '/login'; // Verifica si la ruta es /login

    // Guarda la URL actual si no está definida
    if (this._configurationControlService.urlActual == null || this._configurationControlService.urlActual == undefined) {
      this._configurationControlService.urlActual = state.url;
    }

    // Permite la navegación a /login si no hay token (tras logout) o si activateDemo es true
    if (isLoginRoute && !isAuthenticated) {
      return true; // Permite acceder a /login tras logout
    }

    if (this.activateDemo) {
      return true; // Permite navegación si activateDemo es true (por ejemplo, modo demo)
    }

    // Redirige a /welcome si el usuario está autenticado y no está en /login
    if (isAuthenticated && !isLoginRoute) {
      this._router.navigate(['/welcome']);
      return false;
    }

    // Redirige a / si no se cumplen las condiciones
    this._router.navigate(['/']);
    return false;
  }
}
